export default __webpack_public_path__ + "static/ehqJtJSa-717f34c17a6e502f2a153651073601ee.svg";